import { lazyNamed, loadable } from '../../../lazy';

export const SendingAnimationLazy = lazyNamed(
  () => import('./SendingAnimation'),
  'SendingAnimation'
);

export const SendingAnimation = loadable(SendingAnimationLazy, null);
